import { createContext, useContext, useEffect } from "react";
import { useQuery } from "react-query";
import { client } from "../utils/sanity";

const PropertyContext = createContext();

let url = `*[_type == "property"]{
    ...,
    location->{
        locationName
    },
    officeType[]{
      price,
      officeTypeRef->{
        officeTypeName,
        officeTypeImage,
        people,
        lowestPrice
      }
  },
  onDemandSpace[]{
    ...,
    onDemandSpaceRef->{
     ...,
    }
  },
  propertyStatusRef->{
    ...,
  }
}`;

const fetcher = () => {
  return client.fetch(url);
};

export const PropertyProvider = ({ children }) => {
  const { data, isLoading, error, isIdle, refetch } = useQuery(
    "properties",
    fetcher,
    {
      refetchOnWindowFocus: false,
      cacheTime: 1000 * 60 * 10,
      enabled: false,
      staleTime: 1000 * 60 * 10,
    }
  );

  useEffect(() => {
    if (isIdle) {
      // console.log("if in property");
      refetch();
    } else {
      // console.log("else in property");
    }
  }, [isIdle, refetch]);

  //console.log("property context", data);
  // console.log("Is idle in property", isIdle);
  const ordering = (a, b) => {
    if (a.propertyStatusRef?.status < b.propertyStatusRef?.status) {
      return -1;
    }

    if (a.propertyStatusRef?.status > b.propertyStatusRef?.status) {
      return 1;
    }

    return 0;
  };
  return (
    <PropertyContext.Provider
      value={{
        properties: data && data.sort(ordering),
        loading: isLoading,
        error: error,
      }}
    >
      {children}
    </PropertyContext.Provider>
  );
};

export const useProperties = () => useContext(PropertyContext);
